import { useHabits } from 'features/tasks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Sizes } from 'shared/components/ui/section';
import { useOpenTaskDetail } from 'shared/contexts/task-detail';
import { ID } from 'shared/types/id';

import { useWeekDate } from '../../contexts/timeframe';
import { HabitsList } from '../habits-list';

export const CompletedHabitsList: React.FC = () => {
  const { t } = useTranslation();
  const weekDate = useWeekDate();
  const habits = useHabits({
    completedOnly: true,
    unArchivedOnly: true,
    undeletedOnly: true,
  });

  const openTaskDetail = useOpenTaskDetail();

  const onHabit = (id: ID) => {
    const habit = habits.find((habit) => habit.id === id);
    if (habit && !habit.frozenAt) {
      openTaskDetail(habit);
    }
  };

  if (!habits.length) {
    return null;
  }

  return (
    <Section
      title={t('pages.habits.completed-section.title')}
      titleCount={habits.length}
      size={Sizes.Small}
      canCollapse
    >
      <HabitsList items={habits} onHabit={onHabit} weekDate={weekDate} />
    </Section>
  );
};
